// require('ub/thirdparty/rx.all.2.3.22.js');

module.exports = require('ub/control/rx/mixins.js');



// WEBPACK FOOTER //
// ./src/require_wrappers/rx.js